// This component shows while the route loader processes the OAuth callback
// The loader in routes.ts handles verification and redirects to home
export default function AuthCallback() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-neutral-900 border-t-transparent mx-auto mb-4"></div>
        <p className="text-sm text-neutral-500">Completing sign in...</p>
      </div>
    </div>
  )
}
